module.exports = __webpack_public_path__ + "static/WhyteInktrap-Bold-d5fda619e54a4948a42c0f133a4ad5ed.woff2";